import React from 'react';

const TONES = {
  science: { bg: 'var(--science-100)', fg: 'var(--science-700)' },
  human:   { bg: 'var(--human-50)',    fg: 'var(--human-600)' },
  neutral: { bg: 'var(--neutral-100)', fg: 'var(--neutral-700)' },
  ink:     { bg: 'var(--neutral-900)', fg: '#fff' },
  solid:   { bg: 'var(--science-400)', fg: 'var(--ink)' },
};

/** Compact status / category label. */
export default function Badge({ tone = 'neutral', dot = false, style, children, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  return (
    <span
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px',
        background: t.bg, color: t.fg,
        fontFamily: 'var(--font-sans)', fontWeight: 'var(--w-medium)', fontSize: 'var(--text-xs)',
        letterSpacing: 'var(--track-eyebrow)', textTransform: 'uppercase',
        borderRadius: 'var(--radius-pill)', lineHeight: 1,
        ...style,
      }}
      {...rest}
    >
      {dot && <span style={{ width: 6, height: 6, borderRadius: 1, background: 'currentColor' }} />}
      {children}
    </span>
  );
}
